import { c as e } from "./index-BwYCDOHZ.js";
const s = "_icon_1jro2_1", o = {
  icon: s,
  "size--xs": "_size--xs_1jro2_5",
  "size--s": "_size--s_1jro2_10",
  "size--m": "_size--m_1jro2_15",
  "size--l": "_size--l_1jro2_20",
  "size--xl": "_size--xl_1jro2_25",
  "color--black": "_color--black_1jro2_30",
  "color--white": "_color--white_1jro2_34",
  "color--green": "_color--green_1jro2_38",
  "color--blue": "_color--blue_1jro2_42"
}, i = e(o.icon, {
  variants: {
    color: {
      black: o["color--black"],
      white: o["color--white"],
      blue: o["color--blue"],
      green: o["color--green"]
    },
    size: {
      xs: o["size--xs"],
      s: o["size--s"],
      m: o["size--m"],
      l: o["size--l"],
      xl: o["size--xl"]
    }
  },
  defaultVariants: {
    color: "white",
    size: "m"
  }
});
export {
  i
};
